__webpack_require__.p = "/resume/projects/gosto/";